module.exports = __webpack_public_path__ + "media/ישב.583d886b.mp3";